import React from 'react';

const LoadingTaskComponent = () => {
    return (
        <div className="h-14 flex justify-center items-start">
            <div className="loader-task"></div>
        </div>
    );
};

export default LoadingTaskComponent;